<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h4 class="header-title mt-0">Pays</h4>
                <b-table
                        :current-page="currentPage"
                        :emptyText="titles.emptyData"
                        :fields="fields"
                        :items="items"
                        :per-page="0"
                        :responsive="true"
                        class="vouchers-table"
                        id="team-table"
                        no-local-sorting
                        show-empty
                >
                    <template #empty="scope">
                        <Loading v-if="inProgess"/>
                        <p class="emptyData" v-if="!inProgess">{{ scope.emptyText }}</p>
                    </template>
                    <template v-slot:cell(name)="data">
                        <img
                                :src="require('@/assets/images/flags/' + data.item.code.toLowerCase() + '.svg')"
                                alt="country-flag"
                                v-if="data.value"
                                width="25"
                        />
                        {{data.item.name}}
                    </template>
                    <template v-slot:cell()="data">
                        <i
                                class="fas fa-check font-20 text-success"
                                v-if="data.value"
                        ></i>
                        <i
                                class="fas fa-times font-20 text-danger"
                                v-if="!data.value"
                        ></i>
                    </template>

                </b-table>
            </div>
        </div>
        <modal-delete :message="'Voulez-vous confirmer la suppression?'" @okPressed="handleOk" id="delete-domain"
                      name="domain"/>
        <modal-success :title=titles.deletePackCountryDomainSuccessTitle @messageFromModal="closeModal"
                       id="success-delete-domain"/>
    </div>
</template>

<script>
    import {
        deletePackCountryDomains,
        getAllPackCountryDomain
    } from '../../shared/services/packCountryDomain.service';
    import {packCountryDomain} from '../../shared/models/packCountryDomain';
    import {filterMixin} from '../../../utils/filterMixin';
    import {getAllTypePacks} from '../../shared/services/typePack.service';
    import {typePack} from '../../shared/models/typePack';
    import {backMixin} from '../../../utils/general/backMixin';
    import ModalDelete from '@/components/common/modal-confirm';
    import ModalSuccess from '../../common/modal-success';
    import {titles} from '../../../utils/general/titles';
    import Loading from '../../common/Loading';

    export default {
        name: 'countryTypePack',
        components: {Loading, ModalDelete, ModalSuccess},
        created() {
            this.loadTypePack();
        },
        data() {
            return {
                titles,
                idDomain: this.$cookies.get('domainItem').id != undefined ? this.$cookies.get('domainItem').id : this.$route.params.domainId,
                itemsPackCountryDomain: [],
                itemsTypePack: [],
                itemsCountry: [],
                itemModel: {},
                items: [],
                currentPage: 1,
                fields: [
                    {key: 'name', label: 'Country', sortable: false}
                ],
                countries: [],
                okPressed: null,
                idCountry: Number,
                inProgess: true,
                filterList: []
            };
        },
        mixins: [filterMixin, backMixin],
        methods: {
            async loadPackCountryDomain() {
                this.itemsPackCountryDomain = [];
                this.items = [];
                this.countries = [];
                this.filterList = [];
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'domain.id',
                    this.idDomain,
                    null
                );
                await getAllPackCountryDomain(
                    null, null, null, this.filterQuery
                ).then(response => {
                    this.itemsPackCountryDomain = response.data['hydra:member'];
                    this.itemsPackCountryDomain = this.itemsPackCountryDomain.map(item => packCountryDomain(item));
                    this.itemsPackCountryDomain = this.itemsPackCountryDomain.filter(item => item.country.name != 'default');
                    this.countries = [...new Set(this.itemsPackCountryDomain.map(i => i.country.id))];

                    this.countries.forEach((k, v) => {
                        this.itemModel = {};
                        const country = this.itemsPackCountryDomain.find(item => item.country.id === this.countries[v]).country;
                        this.$set(this.itemModel, 'id', country.id);
                        this.$set(this.itemModel, 'name', country.name);
                        this.$set(this.itemModel, 'code', country.code);
                        this.itemsTypePack.forEach((key, value) => {
                            const exist = this.itemsPackCountryDomain.find(pack => pack.country.id === this.countries[v] && pack.typePack.id === this.itemsTypePack[value].id);
                            const val = exist != undefined;
                            this.$set(this.itemModel, this.itemsTypePack[value].label, val);
                        });
                        this.items.push(this.itemModel);
                    });
                    this.inProgess = false;
                });
            },
            async loadTypePack() {
                this.fields = [
                    {key: 'name', label: 'Country', sortable: false}
                ];
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'enabled',
                    '1',
                    null
                );
                this.orderQueryGenerator('packOrder', false);
                await getAllTypePacks(
                    this.filterQuery, this.sort
                ).then(response => {
                    this.itemsTypePack = response.data['hydra:member'];
                    this.itemsTypePack = this.itemsTypePack.map(item => {
                        this.fields.push({key: item.label, sortable: false});
                        return typePack(item);
                    });
                    this.loadPackCountryDomain();
                });
            },
            deletePackCountryDomains(id) {
                this.$bvModal.show('delete-domain');
                this.idCountry = id;
            },
            handleOk(e) {
                this.okPressed = e;
            },
            closeModal() {
                this.loadPackCountryDomain();
            }
        },
        watch: {
            okPressed() {
                if (this.okPressed) {
                    deletePackCountryDomains(this.idDomain, this.idCountry).then(
                        response => {
                            this.$bvModal.show('success-delete-domain');
                            return response;
                        }
                    );
                }
            }
        }
    };
</script>

<style scoped>

</style>